













































































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { Size } from "@/data/Furniture";
import Physical, { FClass, Material } from "@/data/furniture/Physical";

@Component
export default class PhysicalAttributes extends Vue {
  @Prop()
  readonly value!: Physical;

  @Prop({ default: false })
  readonly readonly!: boolean;

  @Prop()
  readonly fclass!: FClass;

  readonly materials = Object.keys(Material);

  /**
   * Emits changes to the physical attributes.
   * Establishes two-way binding by emitting "input".
   */
  updatePhysical(updates: Partial<Physical>): void {
    this.$emit("input", { ...this.value, ...updates });
  }

  get size(): number {
    return this.value.size;
  }

  set size(value: number) {
    this.updatePhysical({ size: value });
  }

  get material(): string {
    return this.value.material;
  }

  set material(value: string) {
    this.updatePhysical({ material: value as Material });
  }

  get showAltMaterial(): boolean {
    return !!this.altMaterial;
  }

  set showAltMaterial(value: boolean) {
    if (value) this.altMaterial = Material.Wood;
    else this.altMaterial = "";
  }

  get altMaterial(): string {
    return this.value.altMaterial || "";
  }

  set altMaterial(value: string) {
    if (!value) this.updatePhysical({ altMaterial: undefined });
    this.updatePhysical({ altMaterial: value as Material });
  }

  get hasFrame(): boolean {
    return this.value.hasFrame;
  }

  set hasFrame(value: boolean) {
    this.updatePhysical({ hasFrame: value });
  }

  get hasBoxSpring(): boolean {
    return this.value.hasBoxSpring;
  }

  set hasBoxSpring(value: boolean) {
    this.updatePhysical({ hasBoxSpring: value });
  }

  get heavy(): boolean {
    return this.value.heavy;
  }

  set heavy(value: boolean) {
    this.updatePhysical({ heavy: value });
  }

  // These will be set programmatically based on user input
  get set(): boolean {
    return this.value.set;
  }

  set set(value: boolean) {
    this.updatePhysical({ set: value });
  }

  get numChairs(): number {
    return this.value.numChairs;
  }

  set numChairs(value: number) {
    this.updatePhysical({ numChairs: value });
  }

  /**
   * Returns the strings that correspond to the size numbers for a given
   * furniture class.
   */
  getSizes(): string[] {
    return Size[this.fclass];
  }
}
